import { Button, Card } from '@repo/shadcn';
import { Link } from 'react-router-dom';

import { SectionContainer } from '@/components/shared';
import {
    HeaderBreadcrumb,
    SectionDataTable,
    SectionTitle,
} from '@/components/ui';
import { Route } from '@/constants';
import { usePurchaseList } from '@/modules/purchase/purchase-list/purchase-list.hook';
import { purchaseTableColumns } from '@/modules/purchase/purchase-list/purchase-table.column';

export const ExpiredStockAdjustmentList = () => {
    const { data, isLoading, isFetching } = usePurchaseList({
        purchaseType: 'EXPIRY_RESTOCK',
    });

    return (
        <SectionContainer>
            <Card className="space-y-4 p-4">
                <div className="flex justify-between">
                    <div className="space-y-2">
                        <HeaderBreadcrumb
                            items={[{ label: 'Expired Stock Adjustments' }]}
                        />
                        <SectionTitle>Expired Stock Adjustments</SectionTitle>
                    </div>
                    <Link to={Route.STOCK_EXPIRED_PRODUCTS}>
                        <Button>Adjust Expired Stock</Button>
                    </Link>
                </div>

                <SectionDataTable
                    columns={purchaseTableColumns}
                    data={data}
                    isLoading={isLoading || isFetching}
                />
            </Card>
        </SectionContainer>
    );
};

ExpiredStockAdjustmentList.displayName = 'ExpiredStockAdjustmentList';
